import ActiveMark from '../../components/ActiveMark'
import StatusBadge from '../../components/StatusBadge'
import './engagement.css'
import { displayDate } from '../../lib/dates'

/** Cell renderers the four engagement tables share. */

export const indexColumn = (header) => ({
  key: 'index',
  header,
  width: '64px',
  sortable: false,
  searchable: false,
  render: (_row, index) => <span className="eng__index">{index + 1}</span>,
})

export const dateColumn = (key, header) => ({
  key,
  header,
  render: (row) => (
    <span className="eng__date" dir="ltr">
      {displayDate(row[key])}
    </span>
  ),
})

/* The active state as a mark, not a word (2026-10-22) — the word stays its name and the
   column's search and sort value. */
export const statusColumn = (key, header, strings) => ({
  key,
  header,
  align: 'center',
  value: (row) => (row[key] ? strings.active : strings.inactive),
  render: (row) => (
    <ActiveMark active={Boolean(row[key])} label={row[key] ? strings.active : strings.inactive} />
  ),
})

/* Mandatory / not mandatory (and a policy's "force users") in two hues that read apart at a
   glance (2026-10-22): amber for the obligation, sky for the optional. A plain `primary`
   badge is drawn as a grey classification tag, so the old pair came out as two greys. */
export const flagColumn = (key, header, strings) => ({
  key,
  header,
  align: 'center',
  value: (row) => (row[key] ? strings.yes : strings.no),
  render: (row) => (
    <StatusBadge tone={row[key] ? 'warning' : 'info'} plain>
      {row[key] ? strings.yes : strings.no}
    </StatusBadge>
  ),
})
